import { AxiosError } from 'axios'

export const AUTH_SESSION_EXPIRED_CODE = 'ERR_AUTH_SESSION_EXPIRED'

export const isAuthenticationExpiryError = (error: unknown): boolean => {
  return (
    error instanceof AxiosError &&
    (error.code === AUTH_SESSION_EXPIRED_CODE || error.response?.status === 401)
  )
}

export const markAuthenticationExpired = (error: AxiosError): AxiosError => {
  error.code = AUTH_SESSION_EXPIRED_CODE
  return error
}
